// Keep Bootstrap grid utilities (optional) + FontAwesome icons used in content.
import "./src/assets/css/bootstrap.min.css";
import "./src/assets/vendor/fontawesome-free/css/all.min.css";

// New site styling (red/white/black, Dr.-Soot-like layout).
import "./src/styles/global.css";

// gatsby-browser.js
export const shouldUpdateScroll = () => false